const getters = {
  language: state => state.app.language,
  events: state => state.events.event_list,
  apidaysTitle: state => state.apidays.title,
  apidaysData: state => state.apidays.data
}

export default getters

